<mat-sidenav-container
  [hasBackdrop]="false"
  [style.--sidenav-container-width]="sidenavWidth()"
  [style.--mat-sidenav-expanded-width]="sidenavWidthExpanded"
  [style.--mat-sidenav-collapsed-width]="sidenavWidthCollapsed"
  [style.--menu-pad-inline-start]="menuPadInlineStart"
  [style.--menu-pad-inline-end]="menuPadInlineEnd()"
  [style.--menu-pad-block]="menuPadBlock"
>
  @if (showMenu()) {
    <mat-sidenav
      class="sidenav-container"
      [mode]="sidenavMode()"
      [opened]="showMenu()"
      (closedStart)="startCloseSidenav()"
      [disableClose]="!responsiveService.responsive()"
      [class.opened]="isMobileMenuOpened()"
    >
      <wbi-menu
        [isScrolled]="isScrolled()"
        (isMobileMenuOpened)="isMobileMenuOpened.set($event)"
      ></wbi-menu>
    </mat-sidenav>
  }

  <mat-sidenav-content
    #sidenavContent
    (click)="closeMenu()"
    class="app-content"
    [class.iframe-mode]="iframeDetection.inIframe()"
    [class.side-space]="responsiveService.desktop() && showMenu()"
    [class.shrink-space]="responsiveService.medium()"
    [class.fullscreen]="!showMenu()"
    [class.content]="showMenu() && !responsiveService.handset()"
    [class.shrink]="!layoutService.drawerShrink() && showMenu()"
    [class.expand]="layoutService.drawerShrink() && showMenu()"
  >
    @if (!hideNavbar() && showHeaderBar()) {
      <wbi-header-bar></wbi-header-bar>
    }

    <router-outlet></router-outlet>
  </mat-sidenav-content>
</mat-sidenav-container>
@if (showMenu()) {
  <wbi-info-message
    [floating]="true"
    [style.--sidenav-container-width]="sidenavWidth()"
  ></wbi-info-message>
}
